document.addEventListener("DOMContentLoaded", function () {
    document.querySelector(".form-configurator").addEventListener("submit", function (e) {
        const select = document.getElementById("room");
        const selectedText = select.options[select.selectedIndex].text;

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            "event": "configurator",
            "name": "select room",
            "step": "1",
            "room": selectedText,
            "room amount": "1" // aantal ruimtes
        });
    });
});